const fr = {
  // Header / Navigation
  'nav.sports': 'Paris Sportifs',
  'nav.live': 'Paris en Direct',
  'nav.games': 'Jeux',
  'nav.promotions': 'Promotions',
  'nav.deposit': 'Dépôt',
  'nav.myBets': 'Mes Paris',
  'nav.news': 'Actualités',
  'nav.account': 'Compte',
  'nav.login': 'Connexion',
  'nav.register': 'S\'inscrire',
  'nav.logout': 'Déconnexion',

  // Sidebar
  'sidebar.search': 'Équipe, Événement ou Compétition',
  'sidebar.quickAccess': 'Accès Rapide',
  'sidebar.topEvents': 'Événements Principaux',
  'sidebar.topKombis': 'Top Combinés',
  'sidebar.todayMatches': 'Matchs du Jour',
  'sidebar.germanFootball': 'Football Allemand',
  'sidebar.europeanFootball': 'Football Européen',
  'sidebar.topCompetitions': 'Top Compétitions',
  'sidebar.topSports': 'Top Sports',
  'sidebar.allSports': 'Tous les Sports',
  'sidebar.showAllCategories': 'Afficher toutes les catégories',
  'sidebar.hideCategories': 'Masquer les catégories',

  // Sports
  'sport.football': 'Football',
  'sport.tennis': 'Tennis',
  'sport.basketball': 'Basket-ball',
  'sport.iceHockey': 'Hockey sur Glace',
  'sport.handball': 'Handball',
  'sport.baseball': 'Baseball',
  'sport.americanFootball': 'Football Américain',
  'sport.boxing': 'Boxe',
  'sport.cricket': 'Cricket',
  'sport.darts': 'Fléchettes',
  'sport.rugby': 'Rugby',
  'sport.tableTennis': 'Tennis de Table',
  'sport.beachVolleyball': 'Volley-ball de Plage',
  'sport.esports': 'E-Sports',

  // Market Types
  'market.tip': 'Résultat',
  'market.tipRemainingTime': 'Temps Restant',
  'market.firstHalf': '1ère Mi-temps',
  'market.overUnder': 'Plus/Moins',
  'market.doubleChance': 'Double Chance',
  'market.bothTeamsScore': 'Les deux équipes marquent',

  // Bet Outcomes
  'outcome.fhHomeWinRemainingTime': '1ère MT Victoire Dom. Rest.',
  'outcome.fhDrawRemainingTime': '1ère MT Nul Rest.',
  'outcome.fhAwayWinRemainingTime': '1ère MT Victoire Ext. Rest.',
  'outcome.fhNextGoalHome': '1ère MT Prochain But Dom.',
  'outcome.fhNextGoalAway': '1ère MT Prochain But Ext.',
  'outcome.nextGoalHome': 'Prochain But Dom.',
  'outcome.nextGoalAway': 'Prochain But Ext.',
  'market.nextGoal': 'Prochain But',
  'outcome.home': 'Domicile',
  'outcome.away': 'Extérieur',
  'outcome.homeWin': 'Victoire Domicile',
  'outcome.draw': 'Nul',
  'outcome.awayWin': 'Victoire Extérieur',
  'outcome.over': 'Plus',
  'outcome.under': 'Moins',
  'outcome.yes': 'Oui',
  'outcome.no': 'Non',
  'outcome.fhHomeWin': '1MT Victoire Dom.',
  'outcome.fhDraw': '1MT Nul',
  'outcome.fhAwayWin': '1MT Victoire Ext.',
  'outcome.fhOver': '1MT Plus',
  'outcome.fhUnder': '1MT Moins',
  'outcome.homeWinRemainingTime': 'Victoire Dom. (Rest.)',
  'outcome.drawRemainingTime': 'Nul (Rest.)',
  'outcome.awayWinRemainingTime': 'Victoire Ext. (Rest.)',

  // Section Titles
  'section.nextGames': 'Prochains Matchs',
  'section.topEvents': 'Événements Principaux',
  'section.lastMinute': 'Dernière Minute',
  'section.live': 'En Direct',
  'section.next6Hours': '6 Prochaines Heures',
  'section.topKombis': 'Top Combinés',
  'section.topKombisSubtitle': 'd\'autres clients',
  'section.showAll': 'Afficher tout',
  'section.createMkPlus': 'Créer MK+',
  'section.viewAll': 'Tout',

  // Betting Slip
  'slip.title': 'Panier',
  'slip.empty': 'Votre panier est vide.',
  'slip.emptyHint': 'Sélectionnez vos paris maintenant.',
  'slip.single': 'Simple',
  'slip.combi': 'Combiné',
  'slip.system': 'Système',
  'slip.stake': 'Mise',
  'slip.totalStake': 'Mise Totale',
  'slip.setStake': 'Définir la mise',
  'slip.totalOdds': 'Cote Totale',
  'slip.potentialWin': 'Gain Potentiel',
  'slip.placeBet': 'Placer le Pari',
  'slip.openBets': 'Paris Ouverts',
  'slip.viewTicket': 'Voir le Ticket',
  'slip.noOpenBets': 'Vous n\'avez aucun pari ouvert.',
  'slip.combiBet': 'Pari Combiné',
  'slip.singleBet': 'Pari Simple',
  'slip.singleBets': 'Paris Simples',
  'slip.potentialWinShort': 'Gain Pot.',
  'slip.maxWin': 'Gain Max.',
  'slip.requestCashout': 'Demander Cashout',
  'slip.combinations': 'Combinaisons (Voies)',
  'slip.cashoutValue': 'Valeur Cashout',
  'slip.confirmCashout': 'Confirmer Cashout',
  'slip.errorRequestingQuote': 'Erreur lors de la demande de cotation.',
  'slip.cashoutFailed': 'Échec du cashout.',
  'login.failed': 'Échec de la connexion',
  'login.invalidCredentials': 'Identifiants invalides',
  'slip.error.payoutLimitExceeded': 'Limite de gain dépassée. Veuillez réduire votre mise.',
  'slip.errorPlacingBet': 'Erreur lors du placement du pari.',
  'slip.placementScore': 'Placement :',
  'slip.currentScore': 'Actuel :',
  'slip.placingBet': 'Création du ticket...',
  'slip.placingWait': 'Veuillez patienter...',
  'slip.placingBtn': 'Placement en cours...',
  'slip.betSuccess': 'Ticket Approuvé',
  'slip.betSuccessDesc': 'Votre pari a été placé avec succès !',
  'slip.hasLockedBets': 'Votre panier contient des paris verrouillés/suspendus.',

  // Live
  'live.noEvents': 'Aucun événement en direct pour',
  'live.games': 'Jeux',
  'live.sortBy': 'Trier par :',
  'live.time': 'Heure',
  'live.competition': 'Compétition',
  'live.halfTime': 'Mi-temps',
  'live.ht': 'MT',
  'live.ft': 'FM',

  // Time
  'time.today': 'Aujourd\'hui',
  'time.tomorrow': 'Demain',
  'time.minutes': 'Min',
  'time.hoursShort': 'Hrs',

  // Top Kombis Card
  'kombis.betsPlaced': 'Paris placés',
  'kombis.combi': 'Combiné',
  'kombis.totalOdds': 'Cote Totale',
  'kombis.tip': 'Prono',

  // Account
  'account.myAccount': 'Mon Compte',
  'account.loginPrompt': 'Veuillez vous connecter pour gérer votre compte.',
  'account.verification': 'Vérification du Compte',
  'account.management': 'Gestion du Compte & Limites',
  'account.transactions': 'Transactions',
  'account.personalData': 'Données Personnelles',
  'account.responsibleGaming': 'Jeu Responsable',
  'account.meineDaten': 'Mes Données',
  'account.kontoverifizierung': 'Vérification du Compte',
  'account.kontoverwaltung': 'Gestion & Limites',
  'account.transaktionsverlauf': 'Historique des Transactions',
  'account.guthaben': 'Solde',
  'account.auszahlung': 'Retrait',
  'account.einstellungen': 'Paramètres',
  'account.neuigkeiten': 'Actualités',
  'account.apps': 'Applications Tipico',
  'account.kontakt': 'Contact',
  'account.abmelden': 'Déconnexion & Désactivation',
  'account.userTabs.personal': 'Données Utilisateur',
  'account.userTabs.contact': 'Détails de Contact',
  'account.userTabs.password': 'Changer le Mot de Passe',
  'account.fields.name': 'Prénom et Nom :',
  'account.fields.username': 'Nom d\'utilisateur :',
  'account.fields.birthname': 'Nom de Naissance :',
  'account.fields.birthdate': 'Date de Naissance :',
  'account.fields.email': 'Email :',
  'account.fields.emailChange': 'Changer l\'Email',
  'account.fields.lugasId': 'ID Joueur Lugas :',
  'account.underConstruction': 'Cette zone est encore en construction.',
  'account.supportPlaceholder': 'Veuillez décrire votre demande le plus précisément possible...',
  'account.salutationMr': 'M.',
  'account.loginBtn': 'Connexion',
  'account.transactions.title': 'Historique des Transactions',
  'account.transactions.type': 'Type',
  'account.transactions.amount': 'Montant',
  'account.transactions.status': 'Statut',
  'account.transactions.date': 'Date',
  'account.transactions.id': 'ID de Référence',
  'account.transactions.noTransactions': 'Aucune transaction trouvée.',
  'account.transactions.deposit': 'Dépôt',
  'account.transactions.withdrawal': 'Retrait',
  'account.transactions.status.completed': 'Réussi',
  'account.transactions.status.pending': 'En attente',
  'account.transactions.status.failed': 'Échoué',
  'account.transactions.filter.all': 'Tout',
  'account.transactions.filter.startDate': 'De :',
  'account.transactions.filter.endDate': 'À :',
  'account.transactions.filter.reset': 'Réinitialiser',
  'account.balance.title': 'Solde & Portefeuille',
  'account.balance.total': 'Solde Total',
  'account.balance.available': 'Disponible',
  'account.balance.locked': 'Verrouillé',
  'account.balance.realCash': 'Argent Réel',
  'account.balance.bonusCash': 'Solde Bonus',
  'account.balance.premiumWallet': 'Portefeuille Premium',
  'account.balance.depositAction': 'Déposer des Fonds',
  'account.balance.withdrawAction': 'Retirer des Fonds',
  'account.balance.recentActivity': 'Activité Récente',
  'account.balance.viewAllTransactions': 'Voir toutes les transactions',
  'account.notifications.title': 'Actualités & Notifications',
  'account.notifications.empty': 'Aucune notification disponible.',
  'account.notifications.markAllRead': 'Tout marquer comme lu',
  'account.notifications.markRead': 'Marquer comme lu',
  'account.notifications.viewAll': 'Tout voir',
  'account.withdrawal.title': 'Initier un Retrait',
  'account.withdrawal.selectMethod': 'Sélectionner la méthode :',
  'account.withdrawal.amount': 'Montant du Retrait',
  'account.withdrawal.enterAmount': 'Entrer le montant',
  'account.withdrawal.availableToWithdraw': 'Solde disponible :',
  'account.withdrawal.submit': 'Demander le Retrait',
  'account.withdrawal.processingTime': 'Durée',
  'account.withdrawal.instant': 'Instantané',
  'account.withdrawal.bankDays': '1-3 jours ouvrés',
  'account.withdrawal.successMessage': 'Votre demande a été soumise avec succès !',
  'account.withdrawal.successSub': 'Le montant sera crédité sur votre méthode de paiement sous peu.',
  'account.withdrawal.refId': 'ID de Référence :',
  'account.withdrawal.error.insufficient': 'Solde insuffisant.',
  'account.withdrawal.error.minimum': 'Le montant minimum est de 10 €.',
  'account.withdrawal.backToWallet': 'Retour au Solde',

  // Limits & Account Management
  'account.limits.menuTitle': 'Gestion de compte & Limites',
  'account.limits.restrictedSoon': 'Votre compte sera bientôt restreint.',
  'account.limits.restrictedSoonDesc': 'Vérifiez votre identité pour placer des paris, déposer et retirer.',
  'account.limits.verifyNow': 'Vérifier maintenant',
  'account.limits.limits': 'Limites',
  'account.limits.limitsDesc': 'La fonction de limite vous permet d\'imposer des limites quotidiennes, hebdomadaires ou mensuelles sur les dépôts, les pertes ou le temps de jeu.',
  'account.limits.closure': 'Gestion de compte & Auto-exclusion',
  'account.limits.closureDesc': 'La fonction de désactivation vous permet de faire une pause dans le jeu ou de fermer votre compte.',
  'account.limits.history': 'Historique des limites',
  'account.limits.historyDesc': 'Toutes vos limites définies, y compris les dépôts, les pertes et l\'activité de jeu.',
  'account.limits.myLimits': 'Mes limites',
  'account.limits.lugasDeposit': 'Limite de dépôt LUGAS',
  'account.limits.lugasDepositDesc': 'Dernière modification le {date} à {time}. Nous ne pouvons afficher que la limite de dépôt LUGAS que vous avez définie chez Tipico.',
  'account.limits.crossOperator': 'Limite inter-opérateurs',
  'account.limits.changeLimit': 'Modifier la limite',
  'account.limits.lugasHint': '*Votre limite de dépôt inter-opérateurs mensuelle est enregistrée dans le système national des limites (LUGAS). Chaque tentative de dépôt, même chez d\'autres fournisseurs, compte pour votre limite LUGAS.',
  'account.limits.tipicoLimits': 'Limites Tipico (optionnel)',
  'account.limits.tipicoLimitsDesc': 'Limites supplémentaires qui ne s\'appliquent qu\'à Tipico.',
  'account.limits.closureTitle': 'Gestion de compte & Auto-exclusion',
  'account.limits.closureInfo': 'Vous pouvez désactiver votre compte temporairement ou le fermer définitivement.',
  'account.limits.closurePermTitle': 'Fermer le compte Tipico définitivement :',
  'account.limits.closurePermDesc': 'Si vous souhaitez fermer votre compte Tipico définitivement (sans possibilité de réactivation), veuillez contacter notre ',
  'account.limits.closurePermSupport': 'service client',
  'account.limits.closureTempTitle': 'Désactiver le compte Tipico temporairement :',
  'account.limits.closureTempDesc': 'Sélectionnez une période et un motif ci-dessous. Une fois la période écoulée, votre compte sera automatiquement réactivé. Les comptes temporairement désactivés peuvent être réactivés à tout moment.',
  'account.limits.closureCrossTitle': 'Auto-exclusion inter-opérateurs :',
  'account.limits.closureCrossDesc': 'Si vous souhaitez vous exclure des jeux d\'argent pour des raisons de prévention, veuillez sélectionner l\'option ',
  'account.limits.closureCrossOpt': 'Auto-exclusion',
  'account.limits.timePeriod': 'Période :',
  'account.limits.reason': 'Motif :',
  'account.limits.chooseOption': 'Choisissez une option...',
  'account.limits.edit': 'Modifier',
  'account.limits.historyTitle': 'Historique des limites',
  'account.limits.tabLugas': 'Limite Lugas',
  'account.limits.tabSports': 'Limites sportives',
  'account.limits.monthlyDeposit': 'Limite de dépôt mensuelle',

  // Balances
  'account.balance.sportsBalance': 'Solde sports',
  'account.balance.sportsBalanceDesc': 'Ce montant peut être misé sur les sports.',
  'account.balance.withdrawable': 'Retirable',
  'account.balance.withdrawableDesc': 'Montant total disponible pour un retrait.',
  'account.balance.depositWagering': 'Mise de dépôt',
  'account.balance.depositWageringDesc': 'Le montant qui doit être misé avant de pouvoir être retiré. Les dépôts doivent être misés au moins une fois avant que vous puissiez les retirer.',
  'account.balance.bonusBalanceSports': 'Solde bonus Sports',
  'account.balance.bonusBalanceSportsDesc': 'Ce montant est restreint et ne peut être utilisé que dans d\'autres produits Tipico ou retiré une fois les conditions de mise du bonus remplies.',

  // Settings
  'account.settings.general': 'Général',
  'account.settings.language': 'Langue',
  'account.settings.timeZone': 'Fuseau horaire',
  'account.settings.showAccountBalance': 'Afficher le solde du compte',
  'account.settings.betting': 'Paris',
  'account.settings.oddsChanges': 'Changements de cotes',
  'account.settings.oddsChangesDesc': 'Accepter automatiquement les changements de cotes (cotes supérieures et inférieures)',
  'account.settings.communication': 'Communication',
  'account.settings.communicationGroup': 'Communication',

  // Verification
  'account.verification.title': 'Vérifiez votre identité',
  'account.verification.subtitle': 'Prenez simplement des photos de votre pièce d\'identité et un selfie.',
  'account.verification.haveReady': 'Préparez l\'un des documents suivants :',
  'account.verification.idCard': 'Carte d\'identité',
  'account.verification.passport': 'Passeport',
  'account.verification.residencePermit': 'Permis de séjour',
  'account.verification.showAllMethods': 'Afficher toutes les méthodes',
  'account.verification.dataProtection': 'Vos données sont protégées et uniquement utilisées à des fins de vérification.',
  'account.verification.letsGo': 'Allons-y',

  // Login/Register
  'auth.loginTitle': 'Connexion',
  'auth.registerTitle': 'S\'inscrire',
  'auth.email': 'Email',
  'auth.username': 'Nom d\'utilisateur',
  'auth.password': 'Mot de passe',
  'auth.confirmPassword': 'Confirmer le mot de passe',
  'auth.noAccount': 'Pas encore de compte ?',
  'auth.hasAccount': 'Déjà un compte ?',
  'auth.welcomeTitle': 'Plongez dans le monde des paris !',
  'auth.bonusTitle': 'Doublez votre premier dépôt',
  'auth.bonusSubtitle': 'jusqu\'à 100 €',
  'auth.registrationOnlyGermany': 'Inscription disponible uniquement depuis l\'Allemagne.',

  // My Bets
  'bets.myBets': 'Mes Paris',
  'bets.active': 'Actif',
  'bets.settled': 'Réglé',
  'bets.won': 'Gagné',
  'bets.lost': 'Perdu',
  'bets.pending': 'En attente',

  // Misc
  'match.mainBets': 'Paris Principaux',
  'match.allBets': 'Tous les Paris',
  'misc.noOdds': 'Pas de cotes',
  'misc.matches': 'Matchs',
  'misc.matchKombi': 'MatchCombo+',
  'misc.outrights': 'Vainqueurs finaux',
  'misc.statistics': 'Statistiques',
  'misc.search': 'Recherche',
  'misc.close': 'Fermer',
  'misc.load_more': 'Charger plus',
  'misc.back': 'Retour',
  'misc.events': 'Événements',
  'misc.topCompetitions': 'Top Compétitions',
  'misc.noMatches': 'Aucun match à afficher.',
  'misc.loading': 'Chargement…',
  'misc.confirmColon': 'Confirmer :',
  'misc.confirm': 'Confirmer',
  'misc.cancel': 'Annuler',
  'misc.error': 'Erreur.',

  // Casino
  'casino.title': 'Casino',
  'casino.games': 'Jeux de Casino',
  'casino.login_required': 'Veuillez vous connecter ou vous inscrire pour accéder à la section Casino.',
  'casino.login_btn': 'Connexion',
  'casino.search': 'Rechercher des jeux...',
  'casino.search_placeholder': 'Nom du jeu...',
  'casino.all_providers': 'Tous les fournisseurs',
  'casino.unavailable': 'Le casino est actuellement indisponible.',
  'casino.load_failed': 'Échec du chargement des jeux de casino.',
  'casino.not_found': 'Aucun jeu trouvé.',
  'casino.launch_error': 'Impossible de lancer le jeu :',
};

export default fr;
